import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  TableContainer,
  Paper,
  CircularProgress,
  DialogActions,
  Button,
  makeStyles,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import moment from "moment";
import ChatIndex from "../projectsDashboard/ChatIndex";
import CustomButton from "../projectsDashboard/CusomButton";
import NewDeliverySchedulePopup from "./NewDeliverySchedulePopup";
import { updateDeliveryScheduleForecast } from "../../../containers/actions/common/forecastScheduleActions";
import { useDispatch, useSelector } from "react-redux";
import FinalizedSchedule from "./FinalizedSchedule";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronRight } from "@material-ui/icons";
import BackDropLoading from "../models/BackDrop";
import usePrevious from "../../helpers/previousProps";
import { style } from "../../../resources/css/styles";

const useStyles = makeStyles((theme) => ({
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // padding: '1rem',
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  requiredStar: {
    color: "red",
  },
  cancelBtn: {
    border: "1px solid #000000de",
    backgroundColor: "white",
    color: "black",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column", // Display checkboxes vertically
    alignItems: "flex-start", // Align items to the left
  },
  checkboxLabel: {
    fontSize: "14px",
    fontWeight: "500",
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

const CollapsibleForecastSchedule = (props) => {
  const classes = useStyles();
  const { schedule, isExpanded, handleRefresh } = props;
  // Full dataset including CDMO and Final delivery rows
  const dispatch = useDispatch();
  const [error, setError] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [hasLastAgreedSchedule, setHasLastAgreedSchedule] = useState(false);
  const [hasProposedScheduleSponsor, setHasProposedScheduleSponsor] =
    useState(false);
  const [hasProposedScheduleCDMO, setHasProposedScheduleCDMO] = useState(false);
  const [finalizedSchedulePopup, setFinalizedSchedulePopup] = useState(false);
  const [hasFinalSchedule, setHasFinalSchedule] = useState(false);
  const [dsForecastDetails, setDsForecastDetails] = useState([]);
  const [updateSuccessPopup, setUpdateSuccessPopup] = useState(false);

  const [collaboratorTypeID, setCollaboratorTypeID] = useState(null);
  const loggedInCollaboratorTypeID =
    localStorage.collabType === "Pharma Co" ? 1 : 2;

  const [newDeliverySchedulePopup, setNewDeliverySchedulePopup] =
    useState(false);

  const [acceptedButton, setAcceptedButton] = useState(false);
  const [updatePopupText, setUpdatePopupText] = useState("");

  const handleDeliveryScehdulePopup = () => {
    //console.log("clicked");
    setNewDeliverySchedulePopup(!newDeliverySchedulePopup);
  };

  const handleUpdateSuccess = (value) => {
    setFinalizedSchedulePopup(false);
    setNewDeliverySchedulePopup(false);
    setUpdateSuccessPopup(true);
    setUpdatePopupText(value);
  };

  const handleCloseUpdateSuccessPopup = () => {
    setUpdateSuccessPopup(false);
    handleRefresh();
  };

  useEffect(() => {
    let url = null;

    const data = {
      collabrixForecastScheduleID: schedule.collabrixForecastScheduleID,
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDSForecastDetails`,
        data
      )
      .then((res) => {
        // Check if res.data.data and res.data.data.deliveryScheduleForecastDetailsList exist
        if (
          res.data.status
          //   res.data.data
          //   res.data.data.deliveryScheduleForecastDetailsList
        ) {
          const forecastDetailsList =
            res.data.data.deliveryScheduleForecastDetailsList;

          // Set the forecast details
          setDsForecastDetails(res.data.data);

          // Check for schedule types
          setHasLastAgreedSchedule(
            forecastDetailsList.some(
              (row) => row.lastAgreedDeliveryDate || row.lastAgreedQuantity
            )
          );

          setHasProposedScheduleSponsor(
            forecastDetailsList.some(
              (row) =>
                row.proposedDeliveryDateSponsor || row.proposedQuantitySponsor
            )
          );
          setHasProposedScheduleCDMO(
            forecastDetailsList.some(
              (row) => row.proposedDeliveryDateCDMO || row.proposedQuantityCDMO
            )
          );
          setHasFinalSchedule(
            forecastDetailsList.some(
              (row) => row.finalDeliveryDate || row.finalQuantity
            )
          );

          // Find the most recent lastUpdatedDate and update collaboratorTypeID
          if (forecastDetailsList.length > 0) {
            const mostRecent = forecastDetailsList.reduce((latest, current) => {
              const latestDate = moment(latest.lastUpdatedDate);
              const currentDate = moment(current.lastUpdatedDate);
              return currentDate.isAfter(latestDate) ? current : latest;
            });

            if (mostRecent.collaboratorTypeID) {
              setCollaboratorTypeID(mostRecent.collaboratorTypeID);
            }
          }

          setIsLoading(false);
        } else {
          // Handle case when data or forecast list is missing
          setIsLoading(false);
          setError(true);
          //console.log("No valid data or forecast details available");
        }
      })
      .catch((err) => {
        //console.log(err);
        setIsLoading(false);
        setError(true);
      });

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);

  const handleAcceptSchedule = () => {
    setAcceptedButton(true);
    const requestObject = {
      status: schedule.status,
      sponsorOrgID: schedule.sponsorOrgID,
      cdmoOrgID: schedule.cdmoOrgID,

      collabrixForecastScheduleID: schedule.collabrixForecastScheduleID,

      //   scheduleAcceptedFlag: schedule.collabrixForecastScheduleID,
      scheduleAcceptedFlag: true,

      //   scheduleFinalizedFlag: schedule.scheduleFinalizedFlag,

      deliveryScheduleForecastDetailsList:
        dsForecastDetails.deliveryScheduleForecastDetailsList.filter(
          (row) => row.changeInDate === true || row.changeInQty === true
        ),
    };

    // Log the final request object
    //console.log("Request object to be sent:", requestObject);
    dispatch(updateDeliveryScheduleForecast(requestObject));
  };

  const openFinalizedSchedulePopup = () => {
    setFinalizedSchedulePopup(true);
  };

  const closeFinalizedSchedulePopup = () => {
    setFinalizedSchedulePopup(false);
  };

  const errRef = useRef();
  const scrollToTop = () => {
    setTimeout(
      () => errRef.current.scrollIntoView({ behavior: "smooth", block: "end" }),
      100
    );
  };

  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const didMountRef = useRef(false);

  const updateDeliveryScheduleForecastData = useSelector(
    (state) =>
      state.pcmp.common.forecastSchedule?.updateDeliveryScheduleForecastData ||
      {}
  );
  const preUpdateDeliveryScheduleForecastData = usePrevious(
    updateDeliveryScheduleForecastData
  );

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(updateDeliveryScheduleForecastData) !==
        JSON.stringify(preUpdateDeliveryScheduleForecastData)
      ) {
        if (
          updateDeliveryScheduleForecastData.status === true &&
          acceptedButton
        ) {
          // setLoading(false);
          setUpdateError(false);
          setUpdatedData(updateDeliveryScheduleForecastData);
          handleUpdateSuccess("Delivery Schedule Accepted Successfully");
          //   setOpenSuccessDialog(true);
        } else if (updateDeliveryScheduleForecastData.status === false) {
          // setLoading(false);
          setUpdateError(true);
          //   scrollToTop();
          setUpdatedData(updateDeliveryScheduleForecastData);
          //   setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [
    updateDeliveryScheduleForecastData,
    preUpdateDeliveryScheduleForecastData,
  ]);

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "100px", // Optional: Set a height to vertically center the loader
              }}
            >
              <CircularProgress />
            </div>
          ) : error ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "100px", // Optional: Set a height to vertically center the loader
                border: "2px solid #FF0000",
                backgroundColor: "#FFF0F0",
                width: "100%",
              }}
            >
              <Typography style={{ textAlign: "center" }}>
                Something went wrong. Please try again.
              </Typography>
            </div>
          ) : dsForecastDetails?.deliveryScheduleForecastDetailsList.length >
            0 ? (
            <Box margin={2} padding={2} borderColor="lightgray">
              <Grid
                container
                spacing={3}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                {/* Last Agreed Delivery Schedule */}
                {((hasLastAgreedSchedule &&
                  hasProposedScheduleCDMO === false) ||
                  (hasLastAgreedSchedule && hasFinalSchedule) ||
                  (hasLastAgreedSchedule &&
                    hasProposedScheduleCDMO === true &&
                    hasProposedScheduleSponsor === false) ||
                  (hasLastAgreedSchedule &&
                    hasProposedScheduleSponsor === false &&
                    hasProposedScheduleCDMO === false)) && (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6">
                      {
                        // hasProposedScheduleCDMO &&
                        // hasProposedScheduleSponsor === false &&
                        schedule.status === "Forecast Schedule Created"
                          ? "Proposed Schedule - Sponsor"
                          : hasProposedScheduleCDMO &&
                            hasProposedScheduleSponsor === false
                          ? "Proposed Schedule - Sponsor"
                          : "Last Agreed Delivery Schedule"
                      }
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Material Type</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>UoM</TableCell>
                          </TableRow>
                        </TableHead>
                        {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                          (row, index) => {
                            let selectedDate = row.lastAgreedDeliveryDate;
                            let selectedQuantity = row.lastAgreedQuantity;

                            const formattedSelectedDate = selectedDate
                              ? moment(selectedDate).format("DD-MMM-YYYY")
                              : "-NA-";

                            return (
                              <TableBody key={index}>
                                <TableRow>
                                  <TableCell style={{ whiteSpace: "nowrap" }}>
                                    {formattedSelectedDate}
                                  </TableCell>
                                  <TableCell>{row.materialType}</TableCell>
                                  <TableCell>{selectedQuantity}</TableCell>
                                  <TableCell>{row.uom}</TableCell>
                                </TableRow>
                              </TableBody>
                            );
                          }
                        )}
                      </Table>
                    </TableContainer>
                  </Grid>
                )}

                {collaboratorTypeID === 1 ? (
                  <>
                    {!hasFinalSchedule && hasProposedScheduleCDMO && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="h6">
                          Proposed Schedule - CMO
                        </Typography>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Material Type</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>UoM</TableCell>
                              </TableRow>
                            </TableHead>
                            {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                              (row, index) => {
                                let selectedDate = row.proposedDeliveryDateCDMO
                                  ? row.proposedDeliveryDateCDMO
                                  : row.lastAgreedDeliveryDate;
                                let selectedQuantity = row.proposedQuantityCDMO
                                  ? row.proposedQuantityCDMO
                                  : row.lastAgreedQuantity;

                                const formattedSelectedDate = selectedDate
                                  ? moment(selectedDate).format("DD-MMM-YYYY")
                                  : "-NA-";

                                return (
                                  <TableBody key={index}>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight:
                                            selectedDate ===
                                            row.proposedDeliveryDateCDMO
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {formattedSelectedDate}
                                      </TableCell>
                                      <TableCell>{row.materialType}</TableCell>
                                      <TableCell
                                        style={{
                                          fontWeight:
                                            selectedQuantity ===
                                            row.proposedQuantityCDMO
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {selectedQuantity}
                                      </TableCell>
                                      <TableCell>{row.uom}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                );
                              }
                            )}
                          </Table>
                        </TableContainer>
                      </Grid>
                    )}
                  </>
                ) : (
                  <>
                    {!hasFinalSchedule && hasProposedScheduleSponsor && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="h6">
                          Proposed Schedule - BMS
                        </Typography>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Material Type</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>UoM</TableCell>
                              </TableRow>
                            </TableHead>
                            {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                              (row, index) => {
                                let selectedDate =
                                  row.proposedDeliveryDateSponsor
                                    ? row.proposedDeliveryDateSponsor
                                    : row.lastAgreedDeliveryDate;
                                let selectedQuantity =
                                  row.proposedQuantitySponsor
                                    ? row.proposedQuantitySponsor
                                    : row.lastAgreedQuantity;

                                const formattedSelectedDate = selectedDate
                                  ? moment(selectedDate).format("DD-MMM-YYYY")
                                  : "-NA-";

                                return (
                                  <TableBody key={index}>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight:
                                            selectedDate ===
                                            row.proposedDeliveryDateSponsor
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {formattedSelectedDate}
                                      </TableCell>
                                      <TableCell>{row.materialType}</TableCell>
                                      <TableCell
                                        style={{
                                          fontWeight:
                                            selectedQuantity ===
                                            row.proposedQuantitySponsor
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {selectedQuantity}
                                      </TableCell>
                                      <TableCell>{row.uom}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                );
                              }
                            )}
                          </Table>
                        </TableContainer>
                      </Grid>
                    )}
                  </>
                )}

                {collaboratorTypeID === 1 ? (
                  <>
                    {!hasFinalSchedule && hasProposedScheduleSponsor && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="h6">
                          Proposed Schedule - BMS
                        </Typography>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Material Type</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>UoM</TableCell>
                              </TableRow>
                            </TableHead>
                            {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                              (row, index) => {
                                let selectedDate =
                                  row.proposedDeliveryDateSponsor
                                    ? row.proposedDeliveryDateSponsor
                                    : row.lastAgreedDeliveryDate;
                                let selectedQuantity =
                                  row.proposedQuantitySponsor
                                    ? row.proposedQuantitySponsor
                                    : row.lastAgreedQuantity;

                                const formattedSelectedDate = selectedDate
                                  ? moment(selectedDate).format("DD-MMM-YYYY")
                                  : "-NA-";

                                return (
                                  <TableBody key={index}>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight:
                                            selectedDate ===
                                            row.proposedDeliveryDateSponsor
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {formattedSelectedDate}
                                      </TableCell>
                                      <TableCell>{row.materialType}</TableCell>
                                      <TableCell
                                        style={{
                                          fontWeight:
                                            selectedQuantity ===
                                            row.proposedQuantitySponsor
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {selectedQuantity}
                                      </TableCell>
                                      <TableCell>{row.uom}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                );
                              }
                            )}
                          </Table>
                        </TableContainer>
                      </Grid>
                    )}
                  </>
                ) : (
                  <>
                    {!hasFinalSchedule && hasProposedScheduleCDMO && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="h6">
                          Proposed Schedule - CMO
                        </Typography>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Material Type</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>UoM</TableCell>
                              </TableRow>
                            </TableHead>
                            {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                              (row, index) => {
                                let selectedDate = row.proposedDeliveryDateCDMO
                                  ? row.proposedDeliveryDateCDMO
                                  : row.lastAgreedDeliveryDate;
                                let selectedQuantity = row.proposedQuantityCDMO
                                  ? row.proposedQuantityCDMO
                                  : row.lastAgreedQuantity;

                                const formattedSelectedDate = selectedDate
                                  ? moment(selectedDate).format("DD-MMM-YYYY")
                                  : "-NA-";

                                return (
                                  <TableBody key={index}>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight:
                                            selectedDate ===
                                            row.proposedDeliveryDateCDMO
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {formattedSelectedDate}
                                      </TableCell>
                                      <TableCell>{row.materialType}</TableCell>
                                      <TableCell
                                        style={{
                                          fontWeight:
                                            selectedQuantity ===
                                            row.proposedQuantityCDMO
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {selectedQuantity}
                                      </TableCell>
                                      <TableCell>{row.uom}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                );
                              }
                            )}
                          </Table>
                        </TableContainer>
                      </Grid>
                    )}
                  </>
                )}

                {/* Proposed Schedule - Sponsor */}
                {/* {!hasFinalSchedule && hasProposedScheduleSponsor && (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6">
                      Proposed Schedule - Sponsor
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Material Type</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>UoM</TableCell>
                          </TableRow>
                        </TableHead>
                        {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                          (row, index) => {
                            let selectedDate = row.proposedDeliveryDateSponsor
                              ? row.proposedDeliveryDateSponsor
                              : row.lastAgreedDeliveryDate;
                            let selectedQuantity = row.proposedQuantitySponsor
                              ? row.proposedQuantitySponsor
                              : row.lastAgreedQuantity;

                            const formattedSelectedDate = selectedDate
                              ? moment(selectedDate).format("DD-MMM-YYYY")
                              : "-NA-";

                            return (
                              <TableBody key={index}>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      whiteSpace: "nowrap",
                                      fontWeight:
                                        selectedDate ===
                                        row.proposedDeliveryDateSponsor
                                          ? "bold"
                                          : "normal",
                                    }}
                                  >
                                    {formattedSelectedDate}
                                  </TableCell>
                                  <TableCell>{row.materialType}</TableCell>
                                  <TableCell
                                    style={{
                                      fontWeight:
                                        selectedQuantity ===
                                        row.proposedQuantitySponsor
                                          ? "bold"
                                          : "normal",
                                    }}
                                  >
                                    {selectedQuantity}
                                  </TableCell>
                                  <TableCell>{row.uom}</TableCell>
                                </TableRow>
                              </TableBody>
                            );
                          }
                        )}
                      </Table>
                    </TableContainer>
                  </Grid>
                )} */}

                {/* Proposed Schedule - CDMO */}
                {/* {!hasFinalSchedule && hasProposedScheduleCDMO && (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6">
                      Proposed Schedule - CDMO
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Material Type</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>UoM</TableCell>
                          </TableRow>
                        </TableHead>
                        {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                          (row, index) => {
                            let selectedDate = row.proposedDeliveryDateCDMO
                              ? row.proposedDeliveryDateCDMO
                              : row.lastAgreedDeliveryDate;
                            let selectedQuantity = row.proposedQuantityCDMO
                              ? row.proposedQuantityCDMO
                              : row.lastAgreedQuantity;

                            const formattedSelectedDate = selectedDate
                              ? moment(selectedDate).format("DD-MMM-YYYY")
                              : "-NA-";

                            return (
                              <TableBody key={index}>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      whiteSpace: "nowrap",
                                      fontWeight:
                                        selectedDate ===
                                        row.proposedDeliveryDateCDMO
                                          ? "bold"
                                          : "normal",
                                    }}
                                  >
                                    {formattedSelectedDate}
                                  </TableCell>
                                  <TableCell>{row.materialType}</TableCell>
                                  <TableCell
                                    style={{
                                      fontWeight:
                                        selectedQuantity ===
                                        row.proposedQuantityCDMO
                                          ? "bold"
                                          : "normal",
                                    }}
                                  >
                                    {selectedQuantity}
                                  </TableCell>
                                  <TableCell>{row.uom}</TableCell>
                                </TableRow>
                              </TableBody>
                            );
                          }
                        )}
                      </Table>
                    </TableContainer>
                  </Grid>
                )} */}

                {hasFinalSchedule && (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6">Finalized Schedule</Typography>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Material Type</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>UoM</TableCell>
                          </TableRow>
                        </TableHead>
                        {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                          (row, index) => {
                            let selectedDate = row.finalDeliveryDate
                              ? row.finalDeliveryDate
                              : row.lastAgreedDeliveryDate;
                            let selectedQuantity = row.finalQuantity
                              ? row.finalQuantity
                              : row.lastAgreedQuantity;

                            const formattedSelectedDate = selectedDate
                              ? moment(selectedDate).format("DD-MMM-YYYY")
                              : "-NA-";

                            return (
                              <TableBody key={index}>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      whiteSpace: "nowrap",
                                      fontWeight:
                                        selectedDate !==
                                        row.lastAgreedDeliveryDate
                                          ? "bold"
                                          : "normal",
                                    }}
                                  >
                                    {formattedSelectedDate}
                                  </TableCell>
                                  <TableCell>{row.materialType}</TableCell>
                                  <TableCell
                                    style={{
                                      fontWeight:
                                        selectedQuantity !==
                                        row.lastAgreedQuantity
                                          ? "bold"
                                          : "normal",
                                    }}
                                  >
                                    {selectedQuantity}
                                  </TableCell>
                                  <TableCell>{row.uom}</TableCell>
                                </TableRow>
                              </TableBody>
                            );
                          }
                        )}
                      </Table>
                    </TableContainer>
                  </Grid>
                )}

                <Grid item xs={12} sm={4}>
                  <Grid
                    container
                    direction="column"
                    spacing={2}
                    alignItems="flex-end"
                  >
                    {/* {hasProposedScheduleCDMO === false && ( */}
                    {collaboratorTypeID === loggedInCollaboratorTypeID &&
                      !hasFinalSchedule &&
                      schedule.scheduleAcceptedFlag === false && (
                        //   localStorage.collabType === "Pharma Co" &&
                        //   (schedule.status === "Forecast Schedule Approved" ||
                        //     schedule.status === "Forecast Schedule Created" )
                        <Grid item>
                          <CustomButton
                            color="#F26336"
                            hoverColor="#D8542E"
                            textColor="#fff"
                            style={{ width: "250px" }} // Set a fixed width for all buttons
                            onClick={() => {
                              handleDeliveryScehdulePopup();
                            }}
                          >
                            Propose New Delivery Schedule
                          </CustomButton>
                        </Grid>
                      )}
                    {((schedule.status === "Schedule Under Negotiation" &&
                      collaboratorTypeID !== loggedInCollaboratorTypeID &&
                      !hasFinalSchedule &&
                      schedule.scheduleAcceptedFlag === false) ||
                      (schedule.status === "Forecast Schedule Created" &&
                        localStorage.collabType !== "Pharma Co" &&
                        schedule.scheduleAcceptedFlag === false)) && (
                      <>
                        <Grid item>
                          <CustomButton // sponsor side: last agreed and cdmo dates are there
                            color="#F26336" // cdmo side: sponsor dates should be there
                            hoverColor="#D8542E"
                            textColor="#fff"
                            style={{ width: "250px" }} // Set the same width for this button
                            onClick={() => {
                              handleAcceptSchedule();
                            }}
                          >
                            Accept Schedule
                          </CustomButton>
                        </Grid>

                        <Grid item>
                          <CustomButton // sponsor side: last agreed and cdmo dates are there
                            color="#F26336" // cdmo side: sponsor dates should be there
                            hoverColor="#D8542E"
                            textColor="#fff"
                            style={{ width: "250px" }} // Set the same width for this button
                          >
                            Reject Schedule
                          </CustomButton>
                        </Grid>
                      </>
                    )}

                    {(((hasProposedScheduleCDMO === true ||
                      hasProposedScheduleSponsor === true) &&
                      collaboratorTypeID !== loggedInCollaboratorTypeID &&
                      !hasFinalSchedule &&
                      schedule.scheduleAcceptedFlag === false) ||
                      (schedule.status === "Forecast Schedule Created" &&
                        localStorage.collabType !== "Pharma Co" &&
                        schedule.scheduleAcceptedFlag === false)) && (
                      <Grid item>
                        <CustomButton // sponsor side:  cdmo dates are there
                          color="#F26336" // cdmo side: sponsor dates are there
                          hoverColor="#D8542E"
                          textColor="#fff"
                          style={{ width: "250px" }} // Set the same width for this button
                          onClick={() => {
                            handleDeliveryScehdulePopup();
                          }}
                        >
                          Propose Counter Schedule
                        </CustomButton>
                      </Grid>
                    )}
                    {schedule.scheduleAcceptedFlag &&
                      schedule?.scheduleFinalizedFlag === null &&
                      schedule.status === "Schedule Under Negotiation" &&
                      localStorage.collabType === "Pharma Co" && (
                        <Grid item>
                          <CustomButton //sponsor side: final dates are present
                            color="#F26336"
                            hoverColor="#D8542E"
                            textColor="#fff"
                            style={{ width: "250px" }} // Set the same width for this button
                            onClick={openFinalizedSchedulePopup}
                          >
                            Finalize Schedule and Send for Approval
                          </CustomButton>
                        </Grid>
                      )}
                    {schedule?.scheduleFinalizedFlag &&
                      schedule.status === "Schedule Under Negotiation" && (
                        <Grid item>
                          <CustomButton // sponsor side: rowFinalizedFlag
                            color="#F26336"
                            hoverColor="#D8542E"
                            textColor="#fff"
                            style={{ width: "250px" }} // Set the same width for this button
                          >
                            Sync SAP and Final Agreed Schedule
                          </CustomButton>
                        </Grid>
                      )}
                    <Grid item>
                      <ChatIndex
                        forecastScheduleChat={true}
                        collabrixForecastScheduleID={
                          schedule.collabrixForecastScheduleID
                        }
                        row={{
                          sponsorOrgID: schedule?.sponsorOrgID,
                          cdmoOrgID: schedule?.cdmoOrgID,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Final Delivery Schedule */}
                {/* {hasFinalSchedule && (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6">
                      Final Delivery Schedule
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Material Type</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>UoM</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                            (row, index) =>
                              row.finalDeliveryDate && (
                                <TableRow key={index}>
                                  <TableCell>
                                    {moment(row.finalDeliveryDate).format(
                                      "DD-MMM-YYYY"
                                    )}
                                  </TableCell>
                                  <TableCell>{row.materialType}</TableCell>
                                  <TableCell>
                                    {row.finalQuantity}
                                  </TableCell>
                                  <TableCell>{row.uom}</TableCell>
                                </TableRow>
                              )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )} */}
              </Grid>
            </Box>
          ) : (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <Typography style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                No Data Found
              </Typography>
            </Box>
          )}
        </Collapse>
      </TableCell>

      {newDeliverySchedulePopup && (
        <NewDeliverySchedulePopup
          openDialog={newDeliverySchedulePopup}
          schedule={schedule}
          handleDeliveryScehdulePopup={handleDeliveryScehdulePopup}
          hasLastAgreedScheduleProp={hasLastAgreedSchedule}
          hasProposedScheduleCDMOProp={hasProposedScheduleCDMO}
          hasProposedScheduleSponsorProp={hasProposedScheduleSponsor}
          hasFinalScheduleProp={hasFinalSchedule}
          dsForecastDetails={dsForecastDetails}
          collaboratorTypeID={collaboratorTypeID}
          loggedInCollaboratorTypeID={loggedInCollaboratorTypeID}
          handleUpdateSuccess={handleUpdateSuccess}
        />
      )}

      {finalizedSchedulePopup && (
        <FinalizedSchedule
          closeFinalizedSchedulePopup={closeFinalizedSchedulePopup}
          openDialog={finalizedSchedulePopup}
          setFinalizedSchedulePopup={setFinalizedSchedulePopup}
          finalizedSchedulePopup={finalizedSchedulePopup}
          schedule={schedule}
          dsForecastDetails={dsForecastDetails}
          handleUpdateSuccess={handleUpdateSuccess}
        />
      )}

      {updateSuccessPopup && (
        <Dialog open={updateSuccessPopup} maxWidth="sm" fullWidth>
          <DialogContent className={classes.dialogContent}>
            <>
              <CheckCircleIcon className={classes.avatar} />

              <Typography
                variant="h6"
                style={{
                  marginTop: "10px",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                {updatePopupText}
              </Typography>
              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                  onClick={handleCloseUpdateSuccessPopup}
                >
                  Ok
                </Button>
              </DialogActions>
            </>
          </DialogContent>
        </Dialog>
      )}
    </TableRow>
  );
};

export default CollapsibleForecastSchedule;
